'use client'

import { CatalogAttribute } from '@marketplace-web/catalog/catalog-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { selectCatalogEvent } from '@marketplace-web/catalog/catalog-page-data'

import useGetCatalogForBreadcrumbs from '../../../hooks/useGetCatalogForBreadcrumbs'

import BreadcrumbsComponent from '../common/Breadcrumbs'
import { ROOT_URL } from '../../../constants/routes'

type Props = {
  showRootBreadcrumb?: boolean
  truncate?: boolean
}

const Breadcrumbs = ({ truncate = false, showRootBreadcrumb = false }: Props) => {
  const { track } = useTracking()
  const translate = useTranslate()
  const catalogs = useGetCatalogForBreadcrumbs()

  const trackCatalogBreadcrumbClick = (catalogId: number) => () => {
    track(selectCatalogEvent({ catalogIds: [catalogId], attributeId: CatalogAttribute.Breadcrumb }))
  }

  const renderCatalogBreadcrumbs = () => {
    return catalogs.map(catalog => (
      <BreadcrumbsComponent.Item
        key={`catalog-${catalog.id}`}
        title={catalog.title}
        url={catalog.url}
        onClick={trackCatalogBreadcrumbClick(catalog.id)}
      />
    ))
  }

  if (!catalogs.length) return null

  return (
    <BreadcrumbsComponent truncate={truncate}>
      {showRootBreadcrumb && (
        <BreadcrumbsComponent.Item
          key="home"
          title={translate('breadcrumbs.home')}
          url={ROOT_URL}
        />
      )}

      {renderCatalogBreadcrumbs()}
    </BreadcrumbsComponent>
  )
}

export default Breadcrumbs
